import type { NotificationType } from '@/api/generated/model/notificationType';
import type { LucideIcon } from 'lucide-react';
import {
  AlertCircle,
  AlertTriangle,
  Bot as BotIcon,
  CheckCircle,
  CreditCard,
  Info,
  Settings,
} from 'lucide-react';

export function getNotificationIcon(type: NotificationType): LucideIcon {
  switch (type) {
    case 'success':
    case 'goal_milestone':
      return CheckCircle;
    case 'error':
    case 'security_alert':
      return AlertCircle;
    case 'warning':
      return AlertTriangle;
    case 'account_update':
    case 'transaction_alert':
      return CreditCard;
    case 'bot_started':
    case 'bot_stopped':
    case 'bot_failed':
    case 'bot_limit_breached':
      return BotIcon;
    case 'system_maintenance':
      return Settings;
    case 'info':
    default:
      return Info;
  }
}

export function getNotificationColor(type: NotificationType, priority: string): string {
  if (priority === 'urgent') return 'text-fin-danger';
  if (priority === 'high') return 'text-fin-warning';

  switch (type) {
    case 'success':
    case 'goal_milestone':
    case 'bot_started':
      return 'text-fin-green';
    case 'error':
    case 'security_alert':
    case 'bot_failed':
    case 'bot_limit_breached':
      return 'text-fin-danger';
    case 'warning':
    case 'bot_stopped':
      return 'text-fin-warning';
    case 'account_update':
    case 'transaction_alert':
      return 'text-fin-info';
    case 'system_maintenance':
      return 'text-fin-gray-400';
    case 'info':
    default:
      return 'text-fin-info';
  }
}
